<template>
  <div class="admin-edit-klass">
    <router-link to="/admin/klasses" class="btn-flat black-text mt-2">
      <i class="material-icons left">arrow_back</i>
      {{ isEng ? 'Go back' : 'Tillbaka' }}
    </router-link>
    <div v-if="!create && klass">
      <h1>Edit klass {{ klass.name }}</h1>
    </div>
    <div v-else-if="create">
      <h1>{{isEng ? 'Create new class' : 'Skapa ny klass'}}</h1>
    </div>
    <div class="edit-wrapper">
      <form>
        <!-- Input klass Name -->
        <div class="row form-row">
          <div class="name-and-points-headers">
            <h4>{{ $store.state.user.langEng ? 'Name' : 'Namn' }}</h4>
            <h4 class="header-points">{{ $store.state.user.langEng ? 'Points' : 'Poäng' }}</h4>
          </div>
          <div class="name-and-points-inputs">
            <div class="admin-input-field">
              <input
                type="text"
                :placeholder="$store.state.user.langEng ? 'klass name' : 'Klass namn'"
                v-model="klass.name"
              />
            </div>
            <div class="admin-input-field period">
              <input
                type="text"
                placeholder="0"
                v-model="klass.points"
              />
            </div>
          </div>
        </div>
        <!-- Input klass Slug -->
        <div class="row form-row">
          <h4>Slug</h4>
          <div class="admin-input-field"
            :class="{'error-outline': slugError}">
            <input
              type="text"
              :placeholder="$store.state.user.langEng ? 'klass slug' : 'Klass slug'"
              v-model="slug"
            />
          </div>
        </div>

        <!-- Select Education -->
        <div class="row form-row">
          <h4>{{ $store.state.user.langEng ? 'Education' : 'Utbildning' }}</h4>
          <admin-select
            v-if="create || klass.schoolId"
            :data="schools"
            :initial="klass.schoolId"
            v-model="klass.schoolId"
            class="admin-select"
          />
        </div>

        <!-- Input klass Curriculum -->
        <div class="row form-row">
          <h4>{{ $store.state.user.langEng ? 'Curriculum' : 'Utbildningsplan' }}</h4>
          <div class="admin-input-field input-icons">
            <input
              type="text"
              :placeholder="$store.state.user.langEng ? 'klass curriculum' : 'Klass utbildningsplan'"
              v-model="klass.curriculum"
            />
            <!-- <a target="_blank" :href="klass.syllabus"><i v-show="klass.syllabus" class="material-icons">pageview</i></a> -->
          </div>
        </div>
        <!-- Input klass Syllabus -->
        <div class="row form-row">
          <h4>{{ $store.state.user.langEng ? 'Cover' : 'Omslag' }}</h4>
          <div class="admin-input-field input-icons">
            <input
              type="text"
              :placeholder="$store.state.user.langEng ? 'klass cover' : 'Klass omslag'"
              v-model="klass.cover"
            />
            <!-- <a target="_blank" :href="klass.syllabus"><i v-show="klass.syllabus" class="material-icons">pageview</i></a> -->
          </div>
        </div>
        <!-- Input klass Start Date -->
        <div class="row form-row">
          <h4>
            {{ $store.state.user.langEng ? 'Start of education' : 'Utbildningsstart' }}
          </h4>
          <div class="admin-input-field period">
            <!-- <span>{{ getWeek(klass.start) }}</span> -->
              <!-- :value="`(v${startWeek}) ${klass.start.toISOString().slice(0, 10)}`" -->
            <input :placeholder="$store.state.user.langEng ? 'Start of education' : 'Utbildningsstart'" 
              type="text" 
              :value="`(v${startWeek}) ${klass.start.toISOString().slice(0, 10)}`"
              class="datepicker klass-start">
          </div> 
        </div>
        <!-- Input klass End Date -->
        <div class="row form-row">
          <h4>
            {{ $store.state.user.langEng ? 'Graduation' : 'Examensdatum' }}
          </h4>
          <div class="admin-input-field period">
              <!-- :value="`(v${endWeek}) ${klass.end.toISOString().slice(0, 10)}`" -->
            <input
              type="text"
              class="datepicker klass-end"
              :placeholder="$store.state.user.langEng ? 'Graduation' : 'Examensdatum'"
              :value="`(v${endWeek}) ${klass.end.toISOString().slice(0, 10)}`"
            />
          </div>
        </div>
      </form>
      <!-- side edit panel -->
      <div class="edit-side-panel">
        <div class="form-row">
          <h4 class="pb-2">{{ $store.state.user.langEng ? 'Upload cover' : 'Ladda upp omslag' }}</h4>
          <file-upload id="file-upload"  />
        </div>
        <div class="form-row">
          <h4 class="pb-2 mt-3">{{ $store.state.user.langEng ? 'Upload curriculum' : 'Ladda upp utbildningsplan' }}</h4>
          <file-upload id="file-upload"  />
        </div>
        <div class="form-row pt-5">
          <router-link to="/admin/klasses" class="btn-flat mb-2 text-center" id="newKlassButton">
            {{ $store.state.user.langEng ? 'Cancel' : 'Avbryt' }}
          </router-link>
          <a @click="saveKlass" class="btn-flat mb-2 text-center" id="newKlassButton">
            {{ $store.state.user.langEng ? 'Save' : 'Spara' }}
          </a>
          <a v-if="isMobile" @click="deactivateKlass" class="btn grey white-text">
            {{ 
              klass.inactive ? 
              $store.state.user.langEng ? 'Activate' : 'Aktivera' :
              $store.state.user.langEng ? 'Deactivate' : 'Inaktivera' 
            }}
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator';
import AdminSelect from '@/components/Admin/AdminSelect.vue';
import FileUpload from '@/components/CreateArticle/FileUpload/FileUpload.vue';
import { Api, Rest, getWeek, string_to_slug } from '../utils.js';
import { eventBus } from "@/main";

@Component({
  components: { AdminSelect, FileUpload }
})
export default class AdminEditKlass extends Vue {
  klass = {
    name: '',
    slug: '',
    cover: '',
    curriculum: '',
    points: 0,
    start: new Date(),
    end: new Date(),
    school: [],
    schoolId: '',
    inactive: false
  };
  create = false;
  slugError = false

  @Watch('klass.slug')
  validateSlug(slug) {
    clearTimeout(this.throttleSlug)
    this.throttleSlug = setTimeout(async () => {
      const slugTaken = await Rest.get('Klass', { properties: { slug } })
      this.slugError = (slugTaken.length && slugTaken[0].id != this.klass.id) || false
    }, 200);
  }

  get slug() {
    return this.klass.slug
  }

  set slug(val) {
    this.klass.slug = string_to_slug(val)
  }

  get startWeek() {    
    return getWeek(this.klass.start)
  }

  get endWeek() {
    return getWeek(this.klass.end)
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  get isEng() {
    return this.$store.state.user.langEng;
  }

  get schools() {
    this.initSelectors()
    return this.$store.state.schools.map(s => ({text: s.name, value: s.id}));
  }

  async saveKlass() {
    let klassToSave = {...this.klass}
    klassToSave.points = +klassToSave.points
    klassToSave.year = klassToSave.start.getFullYear()
    klassToSave.start = klassToSave.start.getTime()
    klassToSave.end = klassToSave.end.getTime()
    !klassToSave.cover && (klassToSave.cover = ' ')
    !klassToSave.curriculum && (klassToSave.curriculum = ' ')

    let res, text;
    if(this.klass._id) {
      res = await Rest.put('Klass', klassToSave)
      text = this.$store.state.user.langEng
        ? "Saved class"
        : "Sparade klass"
    } else {
      res = await Rest.post('Klass', klassToSave)
      this.klass._id = res._id
      this.klass.id = res.id

      history.replaceState(null, null, `/admin/klasses/${this.klass.slug}/edit`)

      text = this.$store.state.user.langEng
        ? "Created new class"
        : "Skapade ny klass"
    }
    if(res._id) {
      this.$store.commit("toggleSnackbar", { text })
    }
  }

  async deactivateKlass() {
    let klassToUpdate = {
      id: this.klass.id,
      inactive: !this.klass.inactive
    }

    let res = await Api.post('admin/set-active/Klass', klassToUpdate)
    if(res.id) {
      this.klass.inactive = res.inactive
    }
  }

  initSelectors() {
    setTimeout(() => {
      const elems = document.querySelectorAll('select');
      this.$M.FormSelect.init(elems);
    }, 0);
  }

  async created() {
    if (this.$route.params.slug) {
      const { slug } = this.$route.params;

      let klass = (await Rest.get('Klass', {
        properties: { slug: slug },
        eager: { school: true }
      }))[0];

      klass.start = new Date(klass.start)
      klass.end = new Date(klass.end)
      klass.curriculum = klass.curriculum.trim()

      Object.assign(this.klass, klass)

      if(this.klass.school[0]) {
        this.klass.schoolId = this.klass.school[0].id
        console.log(this.klass.schoolId);
        
      } else {
        let schools = this.$store.state.schools.reduce((acc, curr) => {
          acc[curr.id] = curr.klasses
          return acc
        }, {})

        for(let id in schools) {
          for(let k of schools[id]) {
            if(k.id === this.klass.id) {
              this.klass.schoolId = id
              break
            }
          }
          if(this.klass.schoolId) break
        }

        if(!this.klass.schoolId) this.klass.schoolId = "9cb966ec-c036-48a2-8e50-6b275682bbe2" // others klass id
      }
    } else {
      this.klass.schoolId = "9cb966ec-c036-48a2-8e50-6b275682bbe2" // others klass id
    }

    this.initSelectors()

    eventBus.$on("addImageToMarkdown", (id) => {
      this.klass.cover = id
    })

    eventBus.$on("addFileToContentArea", ({ id }) => {
      this.klass.curriculum = id
    })
  }

  beforeDestroy() {
    eventBus.$off("addImageToMarkdown");
    eventBus.$off("addFileToContentArea");
  }
  mounted() {
    let modalOptions = {
      autoClose: true,
      format: 'yyyy-mm-dd',
      onClose: () => {
        document.querySelector('#header-content').style.zIndex = 5
      }
    }

    let start = document.querySelectorAll('.klass-start');
    this.$M.Datepicker.init(start, { 
      onSelect: d => {
        d.setHours(d.getHours() + 2)
        this.klass.start = d
      }, 
      onOpen: () => {
        document.querySelector('#header-content').style.zIndex = 1
        let date = document.querySelector(".klass-start");
        let instance = this.$M.Datepicker.getInstance(date)
        setTimeout(() => {
          instance.gotoDate(new Date(this.klass.start));
          instance.setDate(new Date(this.klass.start));
        }, 0)
      },
      ...modalOptions});
    let end = document.querySelectorAll('.klass-end');
    this.$M.Datepicker.init(end, { 
      onSelect: d => {
        d.setHours(d.getHours() + 2)
        this.klass.end = d
      },
      onOpen: () => {
        document.querySelector('#header-content').style.zIndex = 1
        let date = document.querySelector(".klass-end");
        let instance = this.$M.Datepicker.getInstance(date)
        setTimeout(() => {
          instance.gotoDate(new Date(this.klass.end));
          instance.setDate(new Date(this.klass.end));
        }, 0)
      },
      ...modalOptions});
  }
}
</script>

<style scoped lang="scss">
.name-and-points-headers {
  display: grid;
  grid-template-columns: 1fr 1fr;
  .header-points {
    text-align: end;
  }
}

.name-and-points-inputs {
  display: grid;
  grid-template-columns: 1fr 50px;
  column-gap: 10px;
}

.admin-edit-klass {
  .edit-wrapper {
    display: grid;
    grid-template-columns: 1fr 0.4fr;
    // column-gap: 1em;

    h4 {
      font-size: 1.2em;
      font-weight: 500;
      padding-bottom: 5px;   
    }

    #file-upload {
      background-color: red;
    }
    .btn-flat {
      border: solid 1px lightgrey;
      color: #595a5e;
      font-weight: bold;
      text-transform: initial;

      &:hover {
        background-color: lightgray;
      }
    }
  }

  h1 {
    font-size: 1.5em;
    font-weight: bold;
    margin-left: 0.8em;
    padding: 0.5em 0 1.5em 0;
  }
  
  .form-row {
    display: grid;
    width: 95%;
    padding-left: 2em;
  }

  .admin-input-field {
    border: 1px solid lightgray;
    border-radius: 4px;
    color: #595a5e;
    padding: 0.2em 0.5em;

    &.input-icons {
      display: grid;
      grid-template-columns: 1fr auto;
      a {
        align-self: center;
        line-height: 1em;
        color: var(--main-text-color);
        &:hover {
          opacity: 60%;
        }
      }
    }
  }
  
  .admin-select {
    border-radius: 4px;
    border: solid 1px lightgrey;
    padding: 0.2em 0 !important;
    color: #595a5e;
  }
}

.mobile {
  .edit-wrapper {
    grid-template: 1fr / 1fr;
  }

  .edit-side-panel .form-row {
    margin: 0;
    padding-left: 1.2em;
    width: 92%;
  }
}
</style>